export function clamp(n, range) {
  const { min, max } = range;

  if (n < min) return min;
  if (n > max) return max;

  return n;
}
